<template>
  <Box padding="large" background-color="white" border-radius="large">
    <Stack align="stretch" showDividers space="large">
      <Simple
        :description="`No order form available at this time. To place an order, contact ${company.name} through one of the methods below.`"
        type="disabled"
      />
      <Stack align="center" space="gutter">
        <img :src="company.logo_url" :title="company.name" class="w-40 object-contain" />
        <Typography color="heading" as="div" variant="h2">{{ company.name }}</Typography>
        <Stack align="center" space="xsmall">
          <Columns v-if="company.phone" align="center" alignY="center" space="small">
            <Column>
              <PhoneIcon class="w-5 h-5 text-gray-500" />
            </Column>
            <Column width="content">
              <Typography color="subtle" as="div" variant="body">
                {{ company.phone }}
              </Typography>
            </Column>
          </Columns>
          <Columns v-if="company.email" align="center" alignY="center" space="small">
            <Column>
              <MailIcon class="w-5 h-5 text-gray-500" />
            </Column>
            <Column width="content">
              <Typography color="subtle" as="div" variant="body">
                {{ company.email }}
              </Typography>
            </Column>
          </Columns>
          <Columns v-if="company.website_url" align="center" alignY="center" space="small">
            <Column>
              <GlobeAltIcon class="w-5 h-5 text-gray-500" />
            </Column>
            <Column width="content">
              <Typography color="subtle" as="div" variant="body">
                {{ company.website_url }}
              </Typography>
            </Column>
          </Columns>
        </Stack>
        <Button
          v-if="company.website_url"
          text="View Website"
          color="primary"
          @click="navigateTo(company.website_url)"
        />
        <Simple
          v-if="!company.phone && !company.email && !company.website_url"
          description="No contact methods available."
          type="disabled"
        />
      </Stack>
    </Stack>
  </Box>
</template>

<script setup>
import { MailIcon, PhoneIcon, GlobeAltIcon } from '@heroicons/vue/solid'
import { Stack, Typography, Box, Button, Column, Columns } from '@aryeo/runway'

import Simple from '@/Runway/Alerts/Simple.vue'

defineProps({
  company: Object,
})

const navigateTo = (url) => {
  window.open(url, '_blank')
}
</script>
